const randomColor = (seed?: number) => {
    const colors = [
        '#009966',
        '#cd5b45',
        '#330066',
        '#eee600',
        '#36454f',
        '#cc338b',
        '#8fbc8f',
        '#9400d3',
        '#dc143c',
        '#6699cc',
        '#ed9121',
        '#c21e56'
    ];

    if (seed) {
        return colors[seed % colors.length];
    }

    return colors[Math.floor(Math.random() * colors.length)];
}

export const useColors = () => {
    return {
        randomColor,
    }
}
